import Vue from 'vue';
import VueRouter from 'vue-router';
import { Position } from 'vue-router/types/router';

import AppRouteConfig from '@/entries/user/router/AppRouteConfig';

Vue.use(VueRouter);

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  scrollBehavior: (): Position => ({
    x: 0,
    y: 0,
  }),
  routes: AppRouteConfig.getVueRouterConfig(),
});

export default router;
